import React from "react";
import { Form, Input, InputNumber, Modal, Select } from "antd";

export const modeOptions = [
  { label: "Хувь (%)", value: "percentage" },
  { label: "Дүн (₮)", value: "amount" },
];

export const orderTypeOptions = [
  { label: "Хүргэлт", value: "delivery" },
  { label: "Очиж авах", value: "pickup" },
  { label: "Хүргэлт & Очиж авах", value: "both" },
];

export const DiscountFormModal = ({
  open,
  title,
  okText,
  onCancel,
  onOk,
  form,
}) => {
  return (
    <Modal title={title} open={open} onCancel={onCancel} onOk={onOk} okText={okText}>
      <Form layout="vertical" form={form}>
        <Form.Item
          label="Код"
          name="code"
          rules={[
            { required: true, message: "Код оруулна уу" },
            { max: 50, message: "Код 50 тэмдэгтээс хэтрэхгүй" },
          ]}
        >
          <Input placeholder="Ж: SUMMER10" />
        </Form.Item>
        <Form.Item
          label="Нэр"
          name="name"
          rules={[{ required: true, message: "Нэр оруулна уу" }]}
        >
          <Input placeholder="Хямдралын нэр" />
        </Form.Item>
        <Form.Item
          label="POS ID"
          name="objectNum"
          rules={[{ required: true, message: "Object дугаар оруулна уу" }]}
        >
          <InputNumber style={{ width: "100%" }} precision={0} placeholder="POS object num" />
        </Form.Item>
        <Form.Item
          label="Төрөл"
          name="mode"
          rules={[{ required: true, message: "Төрөл сонгоно уу" }]}
        >
          <Select options={modeOptions} placeholder="Төрөл сонгоно уу" />
        </Form.Item>
        <Form.Item
          label="Утга"
          name="value"
          rules={[{ required: true, message: "Утга оруулна уу" }]}
        >
          <InputNumber style={{ width: "100%" }} min={0} placeholder="Ж: 10" />
        </Form.Item>
        <Form.Item label="Доод дүн" name="minOrderAmount">
          <InputNumber style={{ width: "100%" }} min={0} placeholder="0" />
        </Form.Item>
        <Form.Item
          label="Захиалгын төрөл"
          name="orderType"
          rules={[{ required: true, message: "Захиалгын төрөл сонгоно уу" }]}
        >
          <Select options={orderTypeOptions} placeholder="Захиалгын төрөл сонгоно уу" />
        </Form.Item>
      </Form>
    </Modal>
  );
};
